<div (mouseenter)="this.dotComService.DisplaySubMenu('')">

    <!-- Core Values Modal -->
    <div id="coreValuesModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content coreValuesModalVideoModalMobile">
                  <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
            <video id="coreValuesVideo" class="coreValuesModalMobile" width="800" height="500" controls>
                <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/CoreValuesHome.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="CloseCoreValuesModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Core Values Modal -->

    <!-- Our Why Modal -->
    <div id="ourWhyModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content coreValuesModalVideoModalMobile">
                  <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
            <video id="ourWhyVideo" class="coreValuesModalMobile" width="800" height="500" controls>
                <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/OurWhyHome.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="CloseOurWhyModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Our Why Modal -->

    <!-- Celebration Modal -->
    <div id="celebrationModal" class="modal">
        <!-- Modal content -->
        <div class="modal-content coreValuesModalVideoModalMobile">
                  <!-- MUST PATH TO A VIRTUAL DIRECTORY AND NOT AZURE STOREAGE FOR This
            BECAUSE VIDEOS DO NOT HAVE THE SKIP AHEAD FUNCTIONALITY WITH AZURE STORAGE 
            THIS IS DUE TO THE WAY AZURE BLOB STORAGES STREAMS THE MP4 -->
            <video id="celebrationVideo" class="coreValuesModalMobile" width="800" height="500" controls>
                <source src="https://harrellspublic2024.azurewebsites.net/Assets/Images/CelebrationOfLifeHome.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <h6 style="text-align: right;margin-top:20px; margin-right:20px"><a
                    class="DIN2014 greenBackground whiteText"
                    style="cursor:pointer;font-size:20px; font-weight: 700; padding:8px; text-decoration: none !important"
                    (click)="CloseCelebrationModal()">Close</a></h6>
        </div>
    </div>
    <!-- End Celebration Modal -->



    <div class="headerImageHeight4" style="background-size: cover; background-position:center;"
        [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'header-image.jpg)'}">
        <div class="row g-0">
            <div style="width:10%"></div>
            <div *ngIf="myHarrellsService.bootstrapViewPortSize != ''" class="text-center whiteText" style="width:80%">
                <h1 *ngIf="(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">ABOUT
                </h1>
                <h1 *ngIf="myHarrellsService.bootstrapViewPortSize && myHarrellsService.bootstrapViewPortSize != '' && !(myHarrellsService.bootstrapViewPortSize == 'xs' || this.myHarrellsService.bootstrapViewPortSize == 'sm')"
                    class="DINNextLTPro-Black whiteText headerImageTextLarge" style="text-transform: uppercase;">GROWING
                    WITH INTEGRITY & PURPOSE SINCE 1941</h1>
            </div>
            <div style="width:10%"></div>
        </div>
    </div>
</div>
<div class="row g-0 whiteBackground text-center growingBetterWorldMobile" style="margin-top:80px">
    <h2 class="Caecilia76BoldItalic greenText" style="font-size: 24px; font-weight: 700;">Rooted in faith. Built on
        service. Proudly employee-owned.</h2>
</div>
<div class="row g-0 whiteBackground" style="margin-bottom:70px">
    <div class="col-md-2"></div>
    <div class="col-md-8 text-center">
        <h3 class="DIN2014Regular blackText growingBetterWorldContentMobile"
            style="font-size: 19px; line-height: 27px;letter-spacing: .38px;margin-top:10px">
            Our story began in 1941 when Ormond and Lucile Harrell purchased a small feed and seed store in downtown
            Lakeland, Florida. What started as a modest, family-run business has grown into a nationwide leader in
            customized agronomic solutions, helping turf managers, lawn care operators, growers, and applicators grow a
            better world.<br><br>From the very beginning, Harrell’s has been guided by unwavering Christian principles,
            a deep commitment to doing what’s right, and a people-first mindset. That foundation of integrity and
            service
            has been carried forward through generations of leadership under Ormond Harrell, Jack Harrell, Sr., Jack
            Harrell, Jr., and now Jack Harrell, III. Each has shaped the company with a clear focus on faith, family,
            and
            a tireless dedication to customer success and commitment to our company’s core values.</h3>
    </div>
    <div class="col-md-2"></div>
</div>

<div class="row lightCremeBackground text-center">
    <div class="row text-center" style="max-width:1200px; margin:auto">
        <div class="col-lg-4 blackText lightCremeBackground expertiseContainer">
            <img class="expertiseIcons" src="{{this.pageImagePaths + 'crossicon.png'}}" alt="harrells-expertise-icon">
            <h4 class="DIN2014Bold blueText lightCremeBackground"
                style="margin-top:5%; font-size:21pt; line-height: 25pt;">
                SERVE, HONOR, <br>AND GLORIFY GOD
            </h4>
            <h6 class="DIN2014Regular textWhite lightCremeBackground"
                style="margin-top:5%; font-size:19px; line-height: 32pt;">
                Christian values are <br>at the center of<br> every decision we <br>make & we lead<br> with a servant’s
                heart.
            </h6>
        </div>
        <div class="col-lg-4 blackText lightCremeBackground specializedContainer">
            <img class="expertiseIcons" src="{{this.pageImagePaths + 'handsicon.png'}}" alt="harrells-solutions-icon">
            <h4 class="DIN2014Bold blueText lightCremeBackground"
                style="margin-top:5%; font-size:21pt; line-height: 25pt;">
                TAKE CARE <br>OF PEOPLE
            </h4>
            <h6 class="DIN2014Regular textWhite lightCremeBackground"
                style="margin-top:5%; font-size:19px; line-height: 32pt;">We prioritize faith, <br>family, and health.
                <br>When we take care of <br>ourselves, we can <br>better takecare of you.
            </h6>
        </div>
        <div class="col-lg-4 blackText lightCremeBackground partnershipContainer">
            <img class="expertiseIcons" src="{{this.pageImagePaths + 'planticon.png'}}" alt="harrells-partnership-icon">
            <h4 class="DIN2014Bold blueText" style="margin-top:5%; font-size:21pt; line-height: 25pt">GROW OUR
                <br>FINANCIAL
                STRENGTH
            </h4>
            <h6 class="DIN2014Regular textWhite " style="margin-top:5%; font-size:19px; line-height: 32pt;">
                We invest in people, <br>manage a focused <br>portfolio, and expand <br>strategically to create
                <br>sustainable growth.
            </h6>
        </div>
        <div class="col-lg-4 lightCremeBackground"></div>
        <div class="d-block d-md-none lightCremeBackground" style="padding-bottom:70px">
            <a class="DINNextLTPro-Black  whiteBackground greenText"
                style="font-size:20pt;padding:6px 22px; text-decoration: none !important" href='/products'>VIEW
                ALL
                PRODUCTS</a>
        </div>
    </div>
</div>


<div class="row g-0 whiteBackground" style="margin-top:70px">
    <div class="col-md-2"></div>
    <div class="col-md-8 text-center">
        <h3 class="DIN2014Regular blackText growingBetterWorldContentMobile"
            style="font-size: 19px; line-height: 27px;letter-spacing: .38px;margin-top:10px">
            In 2016, Harrell’s became proudly employee-owned through the creation of our Employee Stock Ownership Plan
            (ESOP). This transition reflects what we’ve always believed—that our people are our greatest strength. As
            employee-owners, we’re each personally invested in supporting your goals and earning your trust every step
            of
            the way.<br><br>Today, with production and storage facilities across the country, we deliver
            high-quality granular and liquid nutritionals, controlled-release fertilizers (including exclusive
            POLYON®technology), and plant protection products—all backed by expert agronomic insight and personalized
            service.<br><br>For over 80 years, one thing has remained constant: our mission to serve, honor, and
            glorify God by taking care of people. Whether you’re a long-standing partner or new to Harrell’s, we’re
            grateful for the opportunity to grow with you—today, tomorrow, and for generations tocome.</h3>
    </div>
    <div class="col-md-2"></div>
</div>
<div class="row g-0 whiteBackground text-center" style="margin-bottom:70px">
    <h3 class="text-center mt-3">
        <a class="DINNextLTPro-Black lightBlueBackground blueText"
            style=" font-size:20px; font-weight:900; padding:8px; text-decoration: none !important"
            href='/contact'>CONNECT WITH US</a>
    </h3>
</div>


<div class="row g-0 lightCremeBackground text-center" style="padding-top:80px">
    <h2 class="Caecilia76BoldItalic greenText" style="font-size: 28px; font-weight: 700;">Dig Deeper</h2>
</div>
<div class="row g-0 lightCremeBackground text-center">
    <h3 class="DIN2014Regular blackText"
        style="font-size: 19px; line-height: 27px; letter-spacing:.38px; font-weight: 400;">Whether you’re a long-term
        partner or just getting to know us, we welcome you to learn more about our foundation & culture.</h3>
</div>
<div class="lightCremeBackground pt-4 pb-5">
    <div class="row g-0 text-center" style="margin: auto; width:90%">
        <div class="text-center p-0" style="margin:10px !important">
            <div style="display:inline-block;cursor:pointer" (click)="OpenCoreValuesModal()">
                <img class="digDeeperImage" src="{{this.pageImagePaths + 'values.jpg'}}" alt="corevaluesimage"
                    style="cursor:pointer; padding:10px">
                <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Our Values</h4>
                <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">&nbsp;</h4>
                <!-- <h4 CLASS="text-center"><a class="DIN2014Regular blueText"
                        style="cursor:pointer;text-decoration-line:underline; font-size:16px; line-height:19px; font-weight:600">LEARN
                        MORE ></a></h4> -->
            </div>


            <div style="display:inline-block; cursor:pointer" (click)="OpenOurWhyModal()">
                <img class="digDeeperImage" src="{{this.pageImagePaths + 'why.jpg'}}" alt="ourwhyimage"
                    style="cursor:pointer; padding:10px">
                <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Our Why</h4>
                <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">&nbsp;</h4>
                <!-- <h4 CLASS="text-center"><a class="DIN2014Regular blueText"
                        style="text-decoration-line:underline; font-size:16px; line-height:19px; font-weight:600">LEARN
                        MORE ></a></h4> -->
            </div>

            <div style="display:inline-block;cursor:pointer" (click)="OpenCelebrationModal()">
                <img class="digDeeperImage" src="{{this.pageImagePaths + 'celebration.jpg'}}" alt="celebrationimage"
                    style="cursor:pointer; padding:10px">
                <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Jack Harrell, Jr.</h4>
                <h4 class="DIN2014Regular" style="font-size:26px; font-weight:600">Celebration Of Life</h4>
                <!-- <h4 CLASS="text-center"><a class="DIN2014Regular blueText"
                        style="cursor:pointer;text-decoration-line:underline; font-size:16px; line-height:19px; font-weight:600">LEARN
                        MORE ></a></h4> -->
            </div>

        </div>
    </div>
</div>

<div class="row g-0 blueBackground text-center" style="padding-top:80px">
    <h2 class="Caecilia76BoldItalic whiteText" style="font-size: 28px; font-weight: 700;">Exclusively Serving Industry
        Professionals</h2>
</div>
<div class="blueBackground pt-3 majorContainer">
    <div class="row g-0 blueBackground text-center whiteText exclusiveImagesContainer">
        <div class="text-center p-0" style="margin-top:10px; margin-bottom:10px">
            <a href="/golf" alt="golf page">
                <div style="display:inline-block">
                    <img class="exclusiveServingGolf" src="{{this.pageImagePaths + 'golf.png'}}" alt="golf image">
                    <h4 class="DIN2014Regular whiteText" style="font-size:19px; letter-spacing: .38px;;margin-top:10px">
                        GOLF
                        COURSES</h4>
                </div>
            </a>

            <a href="/lawn" alt="lawn page">
                <div style="display:inline-block">
                    <img class="exclusiveServingLawn" src="{{this.pageImagePaths + 'lawn.jpeg'}}" alt="lawn image">
                    <h4 class="DIN2014Regular whiteText" style="font-size:19px; letter-spacing: .38px;;margin-top:10px">
                        LAWN
                        + LANDSCAPE</h4>
                </div>
            </a>
            <a href="/horticulture" alt="hort page">
                <div style="display:inline-block">
                    <img class="exclusiveServingHort" src="{{this.pageImagePaths + 'hort.png'}}" alt="hort image">
                    <h4 class="DIN2014Regular whiteText" style="font-size:19px; letter-spacing: .38px;margin-top:10px">
                        HORTICULTURE</h4>
                </div>
            </a>
            <a href="/turf" alt="sports turf page">
                <div style="display:inline-block">
                    <img class="exclusiveServingSports" src="{{this.pageImagePaths + 'sports.png'}}" alt="sports image">
                    <h4 class="DIN2014Regular whiteText" style="font-size:19px; letter-spacing: .38px;margin-top:10px">
                        SPORTS</h4>
                </div>
            </a>
            <a href="/specialty" alt="specialty page">
                <div style="display:inline-block">
                    <img class="exclusiveServingAg" src="{{this.pageImagePaths + 'ag.png'}}" alt="ag image">
                    <h4 class="DIN2014Regular whiteText" style="font-size:19px; letter-spacing: .38px;margin-top:10px">
                        SPECIALTY AG</h4>
                </div>
            </a>
        </div>
    </div>
    <div class="row g-0"
        style="background-size: cover; background-position:center; padding-top:50px; padding-bottom:40px"
        [ngStyle]="{backgroundImage: 'url(' + this.baseImagePaths + 'harrells-pattern.png)'}">
        <div class="col-lg-12 blackText ">
            <h4 class="Caecilia76BoldItalic whiteText"
                style="display:inline-block;text-align: left; margin-left:10%; font-size:34px; font-weight:700">
                Need a Partner For Success?
            </h4>
            <h3 class="connectContainer"><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/findrep'>CONNECT WITH
                    YOUR
                    REP</a>
            </h3>
        </div>
    </div>
    <div class="row g-0">
        <div class="col-lg-6"
            style="padding-top:50px; padding-bottom:20px; background-size: cover; background-position:center; background-repeat: no-repeat;"
            [ngStyle]="{backgroundImage: 'url(' + this.pageImagePaths + 'we-are.png)'}">
            <h2 class="Caecilia76BoldItalic whiteText"
                style="padding-top:15%; text-align:left; margin-left:10%; font-size:28px;  line-height:.38px">We Are
            </h2>
            <h5 class="DIN2014Regular whiteText "
                style="padding-top:15px;padding-bottom:15%; text-align:left; margin-left:10%; margin-right:10%; font-size:19px; line-height:27px; letter-spacing: .38px; font-weight:400">
                Guided by our company's core values, we are committed to taking care of people by remaining intentional,
                humble, and grateful in everything we do while holding ourselves accountable to God, our fellow
                employee-owners, our customers, and our partners.
            </h5>
        </div>
        <div class="col-lg-6 lightCremeBackground" style="padding-top:50px; padding-bottom:20px">
            <h2 class="Caecilia76BoldItalic blueText"
                style="padding-top:15%; text-align:left; margin-left:10%; font-size:28pxt; line-height:.38px">We Are Not
            </h2>
            <h5 class="DIN2014Regular blackText"
                style="padding-top:15px;padding-bottom:15%; text-align:left; margin-left:10%; margin-right:10%; font-size:19px; line-height:27px; letter-spacing: .38px; font-weight:400">
                We are not focused on single transactions, and we don’t see our customers as numbers. Rather, we are
                committed to forging mutually beneficial relationships that will stand the test of time and help our
                customers and friends grow personally and professionally.
            </h5>
        </div>
    </div>
    <!-- remove per Sam -->
    <!-- expandable list - grid -->
    <!-- <div class="row whiteBackground mt-5 text-center">
    <h2 class="Caecilia76BoldItalic greenText" style="font-size: 28px; font-weight: 700;">Our Promises To You</h2>
</div> -->
    <!-- <div class="text-center; ">
    <div style="border-bottom:solid 1px grey;width:90%; margin:auto">
        <div class="row" (click)="ToggleExpand(1)">
            <h6 class="DIN2014Regular"
                style="padding-bottom:10px;margin-top:25px;display:inline-block;font-size:26px; font-weight:700">
                We Will Be International
                <img *ngIf="this.visableSection == 1" src="{{this.pageImagePaths + 'up-arrow.png'}}" alt="arrow up"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.visableSection != 1" src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <div *ngIf="this.visableSection == 1">
            <div class="row mb-2">
                <div class="col-md-6">
                    <h6 class="DIN2014Regular" style="font-size:19px; line-height:37px; letter-spacing: .38;">
                        Section 1 - need content from SAM</h6>
                </div>
            </div>
        </div>
    </div>
    <div style="border-bottom:solid 1px grey;width:90%; margin:auto">
        <div class="row" (click)="ToggleExpand(2)">
            <h6 class="DIN2014Regular"
                style="padding-bottom:10px;margin-top:25px;display:inline-block;font-size:26px; font-weight:700">
                We Will Hold Ourselves Accountable
                <img *ngIf="this.visableSection == 2" src="{{this.pageImagePaths + 'up-arrow.png'}}" alt="arrow up"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.visableSection != 2" src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <div *ngIf="this.visableSection == 2">
            <div class="row mb-2">
                <div class="col-md-6">
                    <h6 class="DIN2014Regular" style="font-size:19px; line-height:37px; letter-spacing: .38;">
                        Section 2 - need content from SAM</h6>
                </div>
            </div>
        </div>
    </div>
    <div style="border-bottom:solid 1px grey;width:90%; margin:auto">
        <div class="row" (click)="ToggleExpand(3)">
            <h6 class="DIN2014Regular"
                style="padding-bottom:10px;margin-top:25px;display:inline-block;font-size:26px; font-weight:700">
                We Will Remain Humble
                <img *ngIf="this.visableSection == 3" src="{{this.pageImagePaths + 'up-arrow.png'}}" alt="arrow up"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.visableSection != 3" src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <div *ngIf="this.visableSection == 3">
            <div class="row mb-2">
                <div class="col-md-6">
                    <h6 class="DIN2014Regular" style="font-size:19px; line-height:37px; letter-spacing: .38;">
                        Section 3 - need content from SAM</h6>
                </div>
            </div>
        </div>
    </div>
    <div style="border-bottom:solid 1px grey;width:90%; margin:auto">
        <div class="row" (click)="ToggleExpand(4)">
            <h6 class="DIN2014Regular"
                style="padding-bottom:10px;margin-top:25px;display:inline-block;font-size:26px; font-weight:700">
                Gratitude Will Guide Us
                <img *ngIf="this.visableSection == 4" src="{{this.pageImagePaths + 'up-arrow.png'}}" alt="arrow up"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.visableSection != 4" src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <div *ngIf="this.visableSection == 4">
            <div class="row mb-2">
                <div class="col-md-6">
                    <h6 class="DIN2014Regular" style="font-size:19px; line-height:37px; letter-spacing: .38;">
                        Section 4 - need content from SAM</h6>
                </div>
            </div>
        </div>
    </div>
    <div style="border-bottom:solid 1px grey;width:90%; margin:auto">
        <div class="row" (click)="ToggleExpand(5)">
            <h6 class="DIN2014Regular"
                style="padding-bottom:10px;margin-top:25px;display:inline-block;font-size:26px; font-weight:700">
                Brand Promise Five
                <img *ngIf="this.visableSection == 5" src="{{this.pageImagePaths + 'up-arrow.png'}}" alt="arrow up"
                    style="cursor:pointer;float:right;margin-top:10px">
                <img *ngIf="this.visableSection != 5" src="{{this.pageImagePaths + 'down-arrow.png'}}" alt="arrow down"
                    style="cursor:pointer;float:right;margin-top:10px">
            </h6>
        </div>
        <div *ngIf="this.visableSection == 5">
            <div class="row mb-2">
                <div class="col-md-6">
                    <h6 class="DIN2014Regular" style="font-size:19px; line-height:37px; letter-spacing: .38;">
                        Section 5 - need content from SAM</h6>
                </div>
            </div>
        </div>
    </div>
</div> -->

    <div class="whiteBackground" style="padding-left:10px; padding-right:10px">
        <div class="col-xs-12 blueText pt-5" style="text-align:center; padding-top:5%">
            <h3 class="Caecilia76BoldItalic" style="font-size: 28pt; font-weight: 700;">
                Ready to Become a Customer?</h3>
            <h6 class="DIN2014Regular blueText"
                style="text-align:center; margin-left:20%; margin-right:20%; font-size: 16px; line-height: 22px; font-weight: 700; opacity: 55%; padding-bottom:20px">
                Submit the form below and we will reach out to you with more information.</h6>
        </div>
        <div class="row g-0 letUsFormContainer">
            <!-- <div id="hubspotFindRepForm" style="width:430px; margin:auto; color:white">hubspot form here</div> -->
            <div class="row g-0" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="First Name*"
                    class="whitePlaceholder blueText Din2014Regular readyFormInput"
                    [(ngModel)]="this.firstNameRepMatch">
                <input type="text" placeholder="Last Name*"
                    class="whitePlaceholder blueText Din2014Regular rightFormInput readyFormInput"
                    [(ngModel)]="this.lastNameRepMatch">
            </div>
            <div class="row g-0" style="margin:auto;padding-bottom:26px">
                <input type="text" placeholder="Company Name*"
                    class="whitePlaceholder whiteBackground blueText Din2014Regular readyFormInput"
                    [(ngModel)]="this.companyRepMatch">
                <input type="text" placeholder="Job Title*"
                    class="whitePlaceholder blueText Din2014Regular rightFormInput readyFormInput"
                    [(ngModel)]="this.titleRepMatch">
            </div>
            <div class="row g-0" style="margin:auto; padding-bottom:20px">
                <input type="number" placeholder="Phone Number*"
                    class="whitePlaceholder blueText Din2014Regular readyFormInput" [(ngModel)]="this.phoneRepMatch">
                <input type="text" placeholder="Email*"
                    class="whitePlaceholder blueText Din2014Regular rightFormInput readyFormInput"
                    [(ngModel)]="this.emailRepMatch">
            </div>
            <div class="row g-0" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="City*" class="whitePlaceholder blueText Din2014Regular readyFormInput"
                    [(ngModel)]="this.cityRepMatch">
                <input type="text" placeholder="State*"
                    class="whitePlaceholder blueText Din2014Regular rightFormInput readyFormInput"
                    [(ngModel)]="this.stateRepMatch">
            </div>
            <div class="row g-0" style="margin:auto; padding-bottom:20px">
                <input type="text" placeholder="Zip*" class="whitePlaceholder blueText Din2014Regular readyFormInput"
                    [(ngModel)]="this.zipRepMatch">
                <!-- <input type="text" placeholder="State*" class="whitePlaceholder blueBackground whiteText Din2014Regular rightFormInput"
                [(ngModel)]="this.stateRepMatch"> -->
            </div>

            <h4 class="Din2014Regular blueText"
                style="margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                Choose Your Market(s)*</h4>

            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="golfRepMatch"
                    (change)="golfRepMatch = !golfRepMatch">
                <h4 class="Din2014Regular blueText"
                    style="display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Golf</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="horticultureRepMatch"
                    (change)="horticultureRepMatch = !horticultureRepMatch">
                <h4 class="Din2014Regular blueText"
                    style="display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Horticulture</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="sportsTurfRepMatch"
                    (change)="sportsTurfRepMatch = !sportsTurfRepMatch">
                <h4 class="Din2014Regular blueText"
                    style="display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Sports Turf</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="specialtyAgRepMatch"
                    (change)="specialtyAgRepMatch = !specialtyAgRepMatch">
                <h4 class="Din2014Regular blueText"
                    style="display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Specialty Ag</h4>
            </div>
            <div class="matchRepCheckboxContainer">
                <input type="checkbox" style="margin-bottom:26px; display:inline" [checked]="lawnCareRepMatch"
                    (change)="lawnCareRepMatch = !lawnCareRepMatch">
                <h4 class="Din2014Regular blueText"
                    style="display:inline; width:100px; margin-bottom:26px; font-size:19px; line-height:20px; letter-spacing:.38px; font-weight:400">
                    Lawn Care</h4>
            </div>

            <textarea class="whitePlaceholder whiteBackground blueText DIN2014Regular textareaCanWeHelpMobile"
                [(ngModel)]="this.commentsRepMatch" style="padding: 17px 22px 17px 22px; font-size:19px; line-height:20px; 
            letter-spacing:.38px; font-weight:400; 
            border: 1px solid #006792;width:820px; height:100px;" placeholder="How Can We Help?"></textarea>
            <div class="row g-0 blueBackground"
                style="margin-top:26px; text-align: center;width:auto; margin-left:10px; padding:0px">
                <button class="DINNextLTPro-Black whiteText blueBackground"
                    [disabled]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.titleRepMatch == '' || this.cityRepMatch == '' || this.stateRepMatch == ''|| this.zipRepMatch == ''"
                    [ngClass]="this.firstNameRepMatch == '' || this.lastNameRepMatch == '' || this.emailRepMatch == '' || this.phoneRepMatch == '' || this.companyRepMatch == '' || this.titleRepMatch == ''|| this.cityRepMatch == '' || this.stateRepMatch == ''|| this.zipRepMatch == '' ? 'greyDisabled':'' "
                    style="padding:10px 10px 7px 10px;font-size:20px; font-weight: 900; line-height:normal; text-decoration: none !important"
                    (click)="sendEmail()">SUBMIT</button>
            </div>

        </div>
    </div>

    <!-- <div class="row">
    <div class="col-lg-6 greenText" style="padding-right:0px; padding-left:0px; padding-top:80px">
        <h3 class="Caecilia76BoldItalic becomeAHarrellsMobile" style="text-align: right; margin-right:5%; font-size:28px; line-height: 36px;">
            Become A Harrell's Customer<br>Here's How It Works</h3>
        <div class="d-flex justify-content-end">
            <img style="width:10vw; margin-right:5%" src="{{this.baseImagePaths + 'dots.png'}}" alt="market dots image">
        </div>
    </div>
    <div class="col-lg-6 blueText becomeAHarrellsContentOuterMobile" style="padding-left:0px; text-align: left;padding-top:80px; padding-bottom:80px">
        <h3 class="DIN2014Bold becomeAHarrellsContentMobile" style="font-size:26px;line-height:26px"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">1</span>&nbsp;&nbsp;&nbsp;Create An Account</h3>
        <h3 class="DIN2014Bold becomeAHarrellsContentMobile" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">2</span>&nbsp;&nbsp;&nbsp;Place Your Order</h3>
        <h3 class="DIN2014Bold becomeAHarrellsContentMobile" style="font-size:26px; margin-top:3%"><span
                style="font-size: 20px;border-radius: 50%;width: 51px;height: 51px;display: inline-block;text-align: center;padding-top: 15px;"
                class="DINNextLTPro-Black blueBackground whiteText">3</span>&nbsp;&nbsp;&nbsp;Get Support </h3>
        <h3 style="margin-top:50px"><a class="DIN2014Bold greenBackground whiteText becomeAHarrellsContentMobile"
                style="font-size:20px;padding:8px; text-decoration: none !important" href='/findrep'>LET'S
                GROW</a></h3>
    </div>
</div> -->





    <div class="row g-0 coreValuesContainer" (click)="OpenCoreValuesModal()">
        <div class="row g-0">
            <div class="coreValuesMobile" style="width:200px">
                <!-- <div style="z-index: 3;"> -->
                <!-- <iframe [src]='coreValuesURL' click="return:false"  width="200" height="200" style="z-index:2; object-fit: cover;"></iframe> -->
                <img class="coreValuesMobile" src="{{this.pageImagePaths + 'feedstore.jpg'}}" alt="core values image"
                    style="width:176px; height:176px; z-index: 3; cursor:pointer;">
                <!-- </div> -->
            </div>
            <div class="seeWhatMakesMobile" style="margin-left:40px;width:60vw; position: relative">
                <h2 class="Caecilia76BoldItalic greenText" style="font-size: 28px; font-weight: 700;">See What Makes
                    Harrell’s
                    Different</h2>
                <h3 class="DIN2014Regular blackText seeWhatMakesMobileContent"
                    style="font-size: 19px; line-height: 27px; letter-spacing:.38px; font-weight: 400;">Since 1941,
                    Harrell’s
                    has been rooted in core values and guiding principles that put people first. Watch how this
                    works
                    and
                    see
                    why it matters.</h3>
                <h3 class="seeWhatMakesMobileButton" style="position:absolute; bottom:0"><a
                        class="DINNextLTPro-Black lightBlueBackground blueText "
                        style="font-size:20px;padding:8px; text-decoration: none !important"
                        (click)="OpenCoreValuesModal()">WATCH NOW</a></h3>
            </div>
        </div>
    </div>
    <div class="row g-0 blueBackground whiteText" style="padding-top:80px; padding-bottom:80px">
        <div class="row g-0" style="width:80%; margin:auto">
            <h4 class="Caecilia76BoldItalic" style="text-align: LEFT; font-size:28px; font-weight: 700;">Join the best
                team in
                the
                industry!</h4>
        </div>
        <div class="row g-0" style="width:80%; margin:auto">
            <h5 class="DIN2014Regular"
                style="text-align: LEFT; font-size:19px; line-height: 30px; letter-spacing: .38px; font-weight: 400;">At
                the
                heart of our company is a team of dedicated professionals, each bringing unique expertise and passion to
                the
                table. Our diverse backgrounds and collective experience drive our innovative solutions and exceptional
                service. We believe in the power of collaboration and are committed to achieving excellence together.
            </h5>
        </div>
        <div class="row g-0 blueBackground pt-5" style="width:80%; margin:auto">
            <h3><a class="DIN2014Bold whiteBackground greenText"
                    style="font-size:20PX ;padding:8pt; text-decoration: none !important" href='/careers'>OPEN
                    POSITIONS</a>
            </h3>
        </div>
    </div>